import { Dispatch, SetStateAction } from 'react';

import {
  ActionsGroup,
  Button,
  DialogFooterV2,
  Inset,
  useCloseDialog,
  Typography,
  Stack,
} from '@cast/design-system';

import { SelectProviderRadio } from 'components/cluster';

import { CommitmentProvider } from '../../types';

type SelectProviderSlideProps = {
  onNext: () => void;
  activeProvider: CommitmentProvider | undefined;
  setActiveProvider: Dispatch<SetStateAction<CommitmentProvider | undefined>>;
  availableProviders: CommitmentProvider[];
};

export const SelectProviderSlide = ({
  activeProvider,
  onNext,
  setActiveProvider,
  availableProviders,
}: SelectProviderSlideProps) => {
  const closeDialog = useCloseDialog();

  return (
    <div data-testid="select-provider-slide">
      <Inset py={16}>
        <Stack gap={16}>
          <Typography variant="A1">Select K8s provider</Typography>

          <Stack direction="row" gap={16}>
            {availableProviders.map((provider) => (
              <SelectProviderRadio
                isCompact={false}
                key={provider}
                checked={activeProvider === provider}
                onClick={() => setActiveProvider(provider)}
                provider={provider}
                testId={`select-provider-${provider}`}
              />
            ))}
          </Stack>
        </Stack>
      </Inset>
      <DialogFooterV2
        endContent={
          <ActionsGroup>
            <Button
              variant="secondary"
              testId="cancel-button"
              onClick={() => closeDialog()}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={onNext}
              disabled={!activeProvider}
              testId="next-button"
            >
              Next
            </Button>
          </ActionsGroup>
        }
        divider
      />
    </div>
  );
};
